/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';
import {toast} from 'react-toastify';
import {useSelector, useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {ContentHeader, Loader, DatePicker} from '@components';
import {Button, Modal} from 'react-bootstrap';
import {format, intervalToDuration} from 'date-fns';
import {logoutUser} from '@app/store/reducers/auth';
import handleStatus from '../../utils/ajax';
import {getAllUserNames} from '../../services/auth';
import Pagination from '../../components/pagination/index';
import {getMyLeaves} from '../../services/leaves';
import {LeaveInfoContainer} from './leaveInfoComponent';
import {calculateBusinessDays} from '../../utils/leaveDateCalculation';
import {ShowPrompt} from './AllLeaves';
function ModalPopup({leave, handleClose}: any) {
  return (
    <Modal
      show={true}
      onHide={handleClose}
      dialogClassName="custom-modal-width"
      centered
    >
      <>
        <Modal.Header>
          <Modal.Title>Your Leave</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{maxHeight: '400px', overflowY: 'auto'}}>
          <div>
            <div className="modal-field">
              <span className="field-label">Applied On:</span>
              <span className="field-value">
                {format(new Date(leave.created_At), 'MM/dd/yyyy')}
              </span>
            </div>

            <div className="modal-field">
              <span className="field-label">Leave Start Date:</span>
              <span className="field-value">
                {format(new Date(leave.leave_start_date), 'MM/dd/yyyy')}
              </span>
            </div>

            <div className="modal-field">
              <span className="field-label">Leave End Date:</span>
              <span className="field-value">
                {format(new Date(leave.leave_end_date), 'MM/dd/yyyy')}
              </span>
            </div>

            <div className="modal-field">
              <span className="field-label">Reason:</span>
              <span className="field-value">{leave.reason}</span>
            </div>

            <div className="modal-field">
              <span className="field-label">Reason:</span>
              <span className="field-value">{leave.reason}</span>
            </div>

            <div className="modal-field">
              <span className="field-label">Paid Leave:</span>
              <span className="field-value">{leave?.paidLeave || 0}</span>
            </div>

            <div className="modal-field">
              <span className="field-label">Unpaid Leave:</span>
              <span className="field-value">{leave?.unPaidLeave || 0}</span>
            </div>

            <div className="modal-field">
              <span className="field-label">Reported To:</span>
              <span className="field-value">{leave.reported_to.name}</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </>
    </Modal>
  );
}

const Status = ({leave}: any) => {
  if (leave.process) {
    return <span className="badge badge-warning">Pending</span>;
  }

  if (leave.declined) {
    return <span className="badge badge-danger">Declined</span>;
  }

  return <span className="badge badge-success">Approved</span>;
};

const MyLeave = () => {
  const user = useSelector((state: any) => state.auth.currentUser);
console.log(user,'user**************88888')
  const [startDate, setStartDate] = useState(0);
  const [showLoader, setShowLoader] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [leave, setLeave] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [leaves, setLeaves] = useState([]);
  const datePickerRef = React.useRef<{resetDatePicker: () => void} | null>(
    null
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [leaveDetails, setLeaveDetails] = useState(null) as any;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getAll = async (query: any) => {
    setShowLoader(true);
    const resp = await getMyLeaves(query);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

    const allUsers = await getAllUserNames();
    setShowLoader(false);
    if (resp?.data?.ok) {
      if (resp?.data?.data) {
        setLeaves(resp?.data?.data);
        setTotalRecords(resp?.data?.totalRecords);
        if (resp?.data?.leaveDetails) {
          setLeaveDetails(resp?.data?.leaveDetails);
        }
      }
    }
  };
  // console.log(leaveDetails, 'leaveDetails');
  const handleCustomDateChange = ({startDate, endDate}: any) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const filter = () => {
    getAll({startDate, endDate});
  };

  const clear = () => {
    if (datePickerRef?.current) {
      datePickerRef.current.resetDatePicker();
    }
    setStartDate(0);
    setEndDate(0);
    getAll({});
  };

  const getAllLeaves = async () => {
    setShowLoader(true);
    const resp = await getMyLeaves({}, user?._id);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);
    setShowLoader(false);
    if (resp.data.ok) {
      setLeaves(resp.data.data);
    }
  };
  useEffect(() => {
    getAllLeaves();
    getAll({});
  }, []);

  const showLeave = (leave: any) => {
    setShowPopup(true);
    setLeave(leave);
  };

  const handleClose = () => {
    setShowPopup(false);
    setLeave(null);
  };

  // const daysDiff = (startDate, endDate) => {
  //   const diff = intervalToDuration({
  //     start: new Date(startDate),
  //     end: new Date(endDate)
  //   });

  //   const {days, months} = diff;

  //   if (months === undefined || months === 0) {
  //     return days === 0 ? days + 1 + ' day' : days + 1 + ' days';
  //   }

  //   if (months > 0 && days === 0) {
  //     return months === 1 ? months + ' month' : months + ' months';
  //   }

  //   if (months > 0 && days > 0) {
  //     const month = months === 1 ? 'month' : 'months';
  //     const day = days === 1 ? 'day' : 'days';
  //     return `${months} ${month}, ${days} ${day} `;
  //   }
  // };

  const paginate = (pageno: number) => {
    getAll({startDate, endDate, pageNo: pageno});
    setCurrentPage(pageno);
  };

  console.log(leaveDetails, 'leavsdfjfskjsfdjdkffkdfjfdjffklsfjsdl');

  return (
    <div>
      <ContentHeader title="My Leaves" />
      {showPopup && <ModalPopup handleClose={handleClose} leave={leave} />}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">My Leaves</h3>
            </div>
            <div className="card-body">
              <div className="card">
                <div className="card-header d-flex justify-content-end flex-wrap">
                  <div className="col-md-4">
                    <DatePicker
                      ref={datePickerRef}
                      onSelect={handleCustomDateChange}
                    />
                  </div>
                  <div className="col-md-1">
                    <Button onClick={filter} variant="primary">
                      Search
                    </Button>
                  </div>
                  <div className="col-md-1">
                    <Button onClick={clear} variant="primary">
                      Clear
                    </Button>
                  </div>
                  <ShowPrompt userId={user?.data?._id} />
                </div>
                <LeaveInfoContainer
                  totalLeaves={leaveDetails?.totalLeaves}
                  appliedLeaves={leaveDetails?.appliedLeaves}
                  remainingLeaves={leaveDetails?.remainingLeaves}
                  isLeaveExceeded={leaveDetails?.isLeaveExceeded}
                  totalPaidLeave={leaveDetails?.totalPaidLeave}
                  totalUnpaidLeave={leaveDetails?.totalUnpaidLeave}
                />
                <div
                  style={{marginTop: '20px'}}
                  className="card-body table-responsive p-0"
                >
                  {showLoader && <Loader title="" />}
                  {!showLoader && !leaves.length && (
                    <div className="text-center" style={{padding: '20px'}}>
                      <p>No records found.</p>
                    </div>
                  )}
                  {!showLoader && Array.isArray(leaves) && leaves.length > 0 && (
                    <table className="table table-hover text-nowrap">
                      <thead>
                        <tr>
                          <th>Applied on</th>
                          <th style={{textAlign: 'center'}}>Duration</th>
                          <th style={{textAlign: 'center'}}>From</th>
                          <th style={{textAlign: 'center'}}>To</th>
                          <th style={{textAlign: 'center'}}>Status</th>
                          <th style={{textAlign: 'right'}}>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leaves.map((leave: any) => {
                          const {_id: id} = leave; // Destructure the leave object before returning the JSX
                          return (
                            <tr key={id}>
                              <td>
                                {format(
                                  new Date(leave?.created_At),
                                  'dd/MM/yyyy'
                                )}
                              </td>
                              <td style={{textAlign: 'center'}}>
                                {leave.leave_duration &&
                                leave.leave_duration.toLowerCase() ===
                                  'half day'
                                  ? leave.leave_duration.toLowerCase()
                                  : calculateBusinessDays(
                                      leave?.leave_start_date,
                                      leave?.leave_end_date
                                    )}
                              </td>
                              <td style={{textAlign: 'center'}}>
                                {format(
                                  new Date(leave.leave_start_date),
                                  'dd/MM/yyyy'
                                )}
                              </td>
                              <td style={{textAlign: 'center'}}>
                                {format(
                                  new Date(leave.leave_end_date),
                                  'dd/MM/yyyy'
                                )}
                              </td>
                              <td style={{textAlign: 'center'}}>
                                <Status leave={leave} />
                              </td>
                              <td style={{textAlign: 'right'}}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => showLeave(leave)}
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>

            <Pagination
              postsPerPage={postPerPage}
              totalPosts={totalRecords}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyLeave;
